import { dowLetter } from "./adjustUtils";

const cellCode = (c, day, emp) => {
  if ((emp.joined && day.date < emp.joined) || (emp.left && day.date > emp.left)) return { t: "", cls: "bg-zinc-50", off: true };
  if (!c || (c.v === 0 && !c.adj && c.dv === 0 && c.dot === 0)) {
    if (day.dow === 6) return { t: "WO", cls: "text-zinc-400" };
    if (day.holiday) return { t: "H", cls: "text-violet-600" };
    return { t: "·", cls: "text-zinc-300" };
  }
  if (c.v === 1) return { t: "P", cls: "text-emerald-700 bg-emerald-50/60" };
  if (c.v === 0.5) return { t: "½", cls: "text-amber-700 bg-amber-50" };
  return { t: "A", cls: "text-red-600 bg-red-50/60" };
};

function GridCell({ emp, day, onPick }) {
  const c = emp.cells[day.date];
  const code = cellCode(c, day, emp);
  const ring = c?.pending ? "ring-2 ring-inset ring-amber-400" : c?.adj ? "ring-1 ring-inset ring-sky-500" : "";
  return (
    <td className="border-b border-r border-zinc-100 p-0">
      <button type="button" disabled={code.off} onClick={() => onPick({ emp, day, cell: c })}
        data-testid={`adj-cell-${emp.code || emp.id}-${day.date.slice(-2)}`}
        title={c?.pending ? "Change awaiting approval" : c?.adj ? `Adjusted (${c.adj})` : ""}
        className={`w-8 h-9 flex flex-col items-center justify-center text-[11px] font-medium transition-colors hover:bg-zinc-100 disabled:cursor-default disabled:hover:bg-transparent ${code.cls} ${ring}`}>
        <span>{code.t}</span>
        {c?.ot > 0 && <span className="text-[9px] leading-none text-sky-700">{c.ot}h</span>}
      </button>
    </td>
  );
}

export function AdjustmentGrid({ data, q, onPick }) {
  const needle = q.trim().toLowerCase();
  const rows = data.employees.filter(e => !needle || `${e.name} ${e.code}`.toLowerCase().includes(needle));
  return (
    <div className="overflow-auto max-h-[65vh] border border-zinc-200 rounded-md" data-testid="adj-grid">
      <table className="text-xs border-collapse">
        <thead className="sticky top-0 z-20 bg-white">
          <tr>
            <th className="sticky left-0 z-30 bg-white text-left px-3 py-2 border-b border-r border-zinc-200 min-w-[180px]">Employee</th>
            {data.days.map(d => (
              <th key={d.date} title={d.holiday || ""}
                className={`w-8 py-1 border-b border-r border-zinc-100 font-normal ${d.dow === 6 ? "bg-zinc-50 text-zinc-400" : d.holiday ? "text-violet-600" : "text-zinc-600"}`}>
                <div className="font-medium">{d.date.slice(-2)}</div>
                <div className="text-[9px]">{dowLetter(d.dow)}</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(e => (
            <tr key={e.id} data-testid={`adj-row-${e.code || e.id}`}>
              <td className="sticky left-0 z-10 bg-white px-3 py-1 border-b border-r border-zinc-200 whitespace-nowrap">
                <div className="font-medium text-zinc-900">{e.name}</div>
                <div className="text-[10px] text-zinc-500">{e.code}{e.left ? ` · left ${e.left}` : ""}{e.monthly_sheet ? " · monthly sheet" : ""}</div>
              </td>
              {data.days.map(d => <GridCell key={d.date} emp={e} day={d} onPick={onPick}/>)}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={data.days.length + 1} className="text-center text-zinc-500 py-8">No employees match.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
